import { Box, Typography } from "@mui/material";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  ReferenceDot,
  Label,
} from "recharts";
import { ListDivider } from "../../../ui/ListStyles";
import { ChartTooltip, COLORS } from "../../../ui/Theme";
import { useMemo } from "react";

const CustomTooltip = ({ active, payload, y_title }) => {
  if (active && payload && payload.length) {
    const { x, y } = payload[0].payload;
    return (
      <ChartTooltip sx={{ bgcolor: COLORS.SOFTBLUE }}>
        <Typography
          sx={{ fontSize: "12px", fontWeight: 900, direction: "rtl" }}
        >
          {x}
        </Typography>
        <ListDivider />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            color: COLORS.BLUE,
          }}
        >
          <Typography sx={{ fontSize: "12px" }}>{y_title} : </Typography>
          <Typography
            sx={{ fontSize: "12px", fontWeight: 900, direction: "rtl" }}
          >
            {y}
          </Typography>
        </Box>
      </ChartTooltip>
    );
  }
  return null;
};

const Chart = ({ chartData }) => {
  const { history, y_title } = chartData;

  const yValues = useMemo(() => history.map((item) => item.y), [history]);
  const minY = Math.min(...yValues);
  const maxY = Math.max(...yValues);
  const padding = (maxY - minY) * 0.2;

  const latestData = history[history.length - 1];

  return (
    <ResponsiveContainer width="100%" height={300}>
      <AreaChart
        data={history}
        margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
      >
        <defs>
          <linearGradient id="colorBLUE" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={COLORS.BLUE} stopOpacity={0.6} />
            <stop offset="95%" stopColor={COLORS.BLUE} stopOpacity={0} />
          </linearGradient>
        </defs>
        <XAxis
          dataKey="x"
          tick={false}
          axisLine={false}
          height={0}
          padding={{ left: 0, right: 0 }}
        />
        <YAxis
          width={0}
          domain={[minY - padding, maxY + padding]}
          axisLine={false}
          tick={false}
        />
        <Legend
          wrapperStyle={{
            width: "fit-content",
            top: -10,
            right: 0,
            lineHeight: "20px",
          }}
          verticalAlign="top"
          formatter={(value) => {
            if (value === "y") {
              return <span style={{ marginRight: "5px" }}>{y_title}</span>;
            }
            return value;
          }}
        />
        <Tooltip content={<CustomTooltip y_title={y_title} />} cursor={{ fill: COLORS.SOFTGRAY }}/>
        <Area
          type="monotone"
          dataKey="y"
          stroke={COLORS.BLUE}
          strokeWidth={2}
          fill="url(#colorBLUE)"
          dot={false}
        />

        <ReferenceDot
          x={latestData.x}
          y={latestData.y}
          r={5}
          fill={COLORS.BLUE}
          stroke="#FFFFFF"
          strokeWidth={1}
        >
          <Label
            style={{ unicodeBidi: "plaintext" }}
            value={latestData.y}
            position="insideBottomLeft"
            fill={COLORS.BLUE}
            fontSize={12}
            fontWeight={700}
            offset={10}
          />
        </ReferenceDot>
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default Chart;
